/**
 * Created by lin on 2017/4/10.
 */
const hosts = require("./host-conf");
const apiHost = hosts.apiHost;
const oldApiHost = hosts.oldApiHost;
const onlineApi = hosts.onlineApi;
const onlineApiHost = hosts.onlineApiHost;
const redisHost = hosts.redisHost;
const redisPort = hosts.redisPort;
const fileServerIp = hosts.fileServerIp;
const fileServerPort = hosts.fileServerPort;
const fileServerPathname = "/upload";
const fileServiceOrigin = hosts.fileServiceOrigin;
//const conferenceHost = hosts.conferenceHost;
const chatServiceServer = hosts.chatServiceServer;
const chatServiceIpWithPort = hosts.chatServiceIpWithPort;
const sConferencePath = "/Conference";
const isImgGlass = hosts.isImgGlass;
const PORT = hosts.port;
const cmsHost = hosts.cmsHost;
const signHost = hosts.signHost;
const domainType = hosts.domainType;
const liveApi = hosts.liveApi;
const loginHost = hosts.loginHost;
const educationHost = hosts.education;
const baseUrl = hosts.baseUrl;
const websocketHost = hosts.websocketHost;
const conf = {
        version: "2.0.19",
        educationHost,
        loginHost,
        signHost,
        cmsHost,
        PORT,
        redisHost,
        apiHost,
        fileServerIp,
        fileServerPort,
        isImgGlass,
        fileServerPathname,
        fileServiceOrigin,
        chatServiceServer,
        domainType,
        liveApi,
        baseUrl,
        redisPort,
    onlineApiHost,
    websocketHost,
        verifyLoginPicUrl: "/svgVerify",// 验证码接口
        htmlToPdf: onlineApi + "/File/htmlToPdf",
        recipeSyn: onlineApi + "/CertificateAuthority/recipe/syn",//同步签名数据
        getCaSignOpenId: onlineApi + "/CertificateAuthority/getCaSignOpenId",//根据申请单编号获取医生openId
        getCaDoctorStatus: onlineApi + "/CertificateAuthority/doctor/getStatus",//根据医生openId获取CA签名图片
        getCaWebUserByParam: onlineApi + "/CertificateAuthority/getCaWebUserByParam",//根据用户编号获取用户CA信息
        app: {
            addAppVersion: apiHost + "/app/appversion/addAppVersion",//新增
            deleteAppVersionById: apiHost + "/app/appversion/deleteAppVersionById",//根据id删除
            getAppVersionInfo: apiHost + "/app/appversion/getAppVersionInfo",///app/appversion/getAppVersionInfo获取app版本信息（最新一个）
            selectAppVersionByParam: apiHost + "/app/appversion/selectAppVersionByParam",///app/appversion/selectAppVersionByParam根据条件分页查询App版本信息
        },
        sysMessage: {
            getMessageList: apiHost + "/SysMessage/getMessageList",//获取消息管理列表
            getMessageDetails: apiHost + "/SysMessage/getMessageDetails",//获取消息管理详情
        },
        chat: {
            createRoom: chatServiceIpWithPort + "/room/createRoom",// 创建聊天室
            closeRoomByRoomId: chatServiceIpWithPort + "/room/closeRoomByRoomId", // 关闭聊天室
            pushUserInfo: chatServiceIpWithPort + "/user/pushUserInfo", // 推送聊天室成员
            getChatUserInfoByUserId: apiHost + "/Chat/getChatUserInfoByUserId", // 获取通讯用户信息
            getChatFriendsListById: apiHost + "/Chat/getChatFriendsListById", // 通过通讯用户id获取好友列表
            getChatGroupListById: apiHost + "/Chat/getChatGroupListById", // 通过通讯用户id获取用户的群组列表
            getMemberListByGroupId: apiHost + "/Chat/getMemberListByGroupId", // 通过群组ID获取群组成员列表
            getUserListExSelfAndFriend: apiHost + "/Chat/getUserListExSelfAndFriend", // 获取用户可添加的用户列表
            addFriend: apiHost + "/Chat/addFriend", // 添加好友
            getUnsureFriendsListById: apiHost + "/Chat/getUnsureFriendsListById", // 获取待确认好友列表
            sendMessage: apiHost + "/Chat/sendMessage", // 发送消息
            addChatFile: apiHost + "/Chat/addChatFile", // 发送文件，添加文件
            getMsgList: apiHost + "/Chat/getMsgList", // 获取消息列表
            getUnreadMsgList: apiHost + "/Chat/getUnreadMsgList", // 获取未读消息列表
            getFileList: apiHost + "/Chat/getFileList", // 文件列表查询
            getGroupMsgList: apiHost + "/Chat/getGroupMsgList", // 群消息列表
            delChatFile: apiHost + "/Chat/delChatFile", //删除聊天文件
            updateMsgReadStatus: apiHost + "/Chat/updateMsgReadStatus", // 设置消息为已读
            batchAddGroupMember: apiHost + "/Chat/batchAddGroupMember", // 批量新增删除群组成员
            batchDelGroupMember: apiHost + "/Chat/batchDelGroupMember", // 批量删除群组成员
            addGroup: apiHost + "/Chat/addGroup", // 创建群组
            delGroup: apiHost + "/Chat/delGroup", // 解散群组
            delFriend: apiHost + "/Chat/delFriend", // 删除好友
            consultImmediately: apiHost + "/Chat/consultImmediately", // 立即咨询
            getAllUser: apiHost + "/Chat/getAllUser", // 聊天医生列表
        },

        middleInterfaceUrl: "/json",//转发接口
        chart: {
            getImageMonthReport: apiHost + "/Chart/getImageMonthReport",
            getRccOrgCountReport: apiHost + "/Chart/getRccOrgCountReport",
            getSignInStatisticsByLessonId: apiHost + "/Chart/getSignInStatisticsByLessonId",//签到排班统计表
            getOrgTimeStatistical: apiHost + "/Chart/getOrgTimeStatistical",//影像 临床 多学科 获取机构每年每月诊断病例
            getSettleCount: apiHost + "/Chart/getSettleCount",//影像 临床 多学科 获取机构每年每月诊断病例
            getHispitalApplyCount: apiHost + "/Chart/getHispitalApplyCount",//影像 临床 多学科 获取地市机构每年每月诊断病例

            getAllData: apiHost + "/Chart/getAllData",//获取整体统计
            getHospitalConsultation: apiHost + "/Chart/getHospitalConsultation",//获取各医院会诊统计量
            getAreaApplyCount: apiHost + "/Chart/getAreaApplyCount",//获取地区的会诊统计信息
            getPatientCount: apiHost + "/Chart/getPatientCount",//获取患者统计信息
            getMonthApplyCount: apiHost + "/Chart/getMonthApplyCount",//获取每个月份的会诊量统计信息
            getStatisticalOrgList: apiHost + "/Chart/getStatisticalOrgList",//获取统计机构下拉列表

            getHospitalStatistical: apiHost + "/Chart/getHospitalStatistical",//获取各医院统计
            getComments: apiHost + "/Chart/getComments",//获取评价列表
            getHospitalNotice: apiHost + "/Chart/getHospitalNotice",//获取医院报警信息

            selectOrgConsStatisticalByParam: apiHost + "/orgConsStatistical/selectOrgConsStatisticalByParam",//根据条件查询专家会诊情况月统计表
        },
        account: {
            login: apiHost + "/Account/login",
            getPermission: apiHost + "/Account/getPermission",
            getSystemInfoByToken: apiHost + "/Account/getSystemInfoByToken",
            changeClientOrg: apiHost + "/Account/changeClientOrg",
            getClientOrgId: apiHost + "/Account/getClientOrg",
            loginout: apiHost + "/Account/loginout",//用户退出注销
            getPersonAccountList: apiHost + "/UserAccount/getPersonAccountList",//查询个人账户
            accountReCharge: apiHost + "/UserAccount/accountReCharge",//账户充值
            getSelectOrgListBySubCenter: apiHost + "/Org/getSelectOrgListBySubCenter",//获取分中心下正常状态的机构列表(不分页，用于下拉)
            getDeptByUserOrgId: apiHost + "/Dept/getDeptByUserOrgId",//根据机构id获取科室下拉列表
            getOrgAccountList: apiHost + "/UserAccount/getOrgAccountList",//获取机构账户列表
            updateUserAccount: apiHost + "/UserAccount/updateUserAccount",//修改账户信息
            addUserAccount: apiHost + "/UserAccount/addUserAccount",//新增账户
            getSelectAccountList: apiHost + "/UserAccount/getSelectAccountList",//获取分中心下机构/个人下拉列表
            getNewIncomeNoByAccountNo: apiHost + "/UserAccount/getNewIncomeNoByAccountNo",//根据账户编号获取新流水号
            changeAccountStatus: apiHost + "/UserAccount/changeAccountStatus",//修改账户状态
            getIncomeListBetweenTime: apiHost + "/UserAccount/getIncomeListBetweenTime",//获取指定时间内账号的流水
            getAccountInfoById: apiHost + "/UserAccount/getAccountInfoById",//根据账户id获取账户信息
            getSubCenterId: apiHost + "/Account/getSubCenterId",//根据token获取当前分中心id
        },
        system: {
            //字典
            dictionary: {
                getDictClasses: apiHost + "/BaseDictClass/getDictClassesWithToken",// 字典类型
                saveDictClass: apiHost + "/BaseDictClass/saveDictClassWithToken",// 添加字典类型
                updateDictClass: apiHost + "/BaseDictClass/updateDictClassWithToken",// 更新字典类型
                deleteDictClassByKey: apiHost + "/BaseDictClass/deleteDictClassByKeyWithToken",// 删除字典类型
                getDictsByUpperId: apiHost + "/BaseDict/getDictsByUpperIdWithToken",// 字典
                getDictByCodeWithToken: apiHost + "/BaseDict/getDictByCodeWithToken", //根据classCode获取层级字典,这个方法只适用于一二级在DictClass表，三级在Dict表的情况
                getDictByKeyWithToken: apiHost + "/BaseDict/getDictByKeyWithToken", //通过主键获取字典信息
                getOnlyDictByCode: apiHost + "/BaseDict/getOnlyDictByCode", //根据code获取字典
                saveDict: apiHost + "/BaseDict/saveDictWithToken",// 新增字典
                updateDict: apiHost + "/BaseDict/updateDictWithToken",// 修改字典
                deleteDictByKey: apiHost + "/BaseDict/deleteDictByKeyWithToken",// 删除字典
                getDictByDictCode: apiHost + "/BaseDict/getDictByDictCode",// 根据dictCode获取t_base_dict表的id、dictName
                getConsultationTip: apiHost + "/BaseDict/getConsultationTip",// 获取提示内容接口 consultType：申请会诊类型（0-影像会诊 1-临床会诊 2-多学科）
            },
            org: {
                deleteBaseAreaByKey: apiHost + "/BaseArea/deleteBaseAreaByKey",//删除地区数据
                updateBaseAreaById: apiHost + "/BaseArea/updateBaseAreaById",//更新修改地区数据
                saveBaseArea: apiHost + "/BaseArea/saveBaseArea",//新增地区数据
                getAllBaseAreaCascade: apiHost + "/BaseArea/getAllBaseAreaCascade",//获取全地区级联数据
                getBaseAreaByUpperId: apiHost + "/BaseArea/getBaseAreaByUpperId", //医学机构的省市
                getProvinceAndCity: apiHost + "/OrgInfo/getByProvinceAndCityAndOrgWithToken", //医院机构列表模糊搜索
                getUpdateStatus: apiHost + "/Org/updateStatusWithToken", //医院机构列表禁用
                getUpdateOrganazation: apiHost + "/Org/updateOrganazationWithToken", //医院机构编辑修改成功的提示
                getOrganazationInfoById: apiHost + "/Org/getOrganazationInfoByIdWithToken", //医院机构编辑id
                addOrganazation: apiHost + "/Org/addOrganazationWithToken", //医院机构的机构新增
                getOrgIdbyWebsite: apiHost + "/Org/getOrgIdbyWebsite", //通过域名获取机构Id
                getSubCenterIdByWebsite: apiHost + "/SubCenter/getSubCenterIdByWebsite", //根据域名获取分中心Id
                getOrgList: apiHost + "/Org/getOrgList", //获取机构信息列表


                getCityListByTokenOrg: apiHost + "/OrgInfo/getCityListByTokenOrg",//根据token对应的orgId获取城市列表及其下属机构
                getDoctorByOrgDeptName: apiHost + "/Org/getDoctorByOrgDeptName",//根据角色id、医院id、科室id、医生姓名查询科室下人员信息
                getOrgDeptBySponsorOrgId: apiHost + "/Org/getOrgDeptBySponsorOrgId",//根据token获取基层机构列表及下属科室
                getOrgById: apiHost + "/Org/getOrgById",//根据机构id获取机构信息
                updateSignVerify: apiHost + "/OrgInfo/updateSignVerify",//根据机构id更新用户签名短信验证状态
                updateCAVerify: apiHost + "/OrgInfo/updateCAVerify",//根据机构id更新CA签名状态
            },
            UserRole: {
                saveByUsersRole: apiHost + "/UserRole/saveByUsersRole",//（批量）赋予角色
                deleteByUserRole: apiHost + "/UserRole/deleteByUserRole",//（批量）取消角色
                getUserRoleByName: apiHost + "/UserRole/getUserRoleByName",//根据userName 获取用户角色关联详细信息
                addUserRole: apiHost + "/UserRole/addUserRole",//添加用户角色关联信息
                updateUserRole: apiHost + "/UserRole/updateUserRole",//更新用户角色
            },
            dept: {
                getDeptByOrgIdWithToken: apiHost + "/Dept/getDeptByOrgIdWithToken",//通过机构id获取机构下的科室
                getBySubjectAndDeptWithToken: apiHost + "/Dept/getBySubjectAndDeptWithToken",//科室搜索按钮
                updateDisableStatusWithToken: apiHost + "/Dept/updateDisableStatusWithToken",//禁用科室
                addDepartmentWithToken: apiHost + "/Dept/addDepartmentWithToken",//添加科室信息
                updateDepartmentWithToken: apiHost + "/Dept/updateDepartmentWithToken",//更新科室信息
                getDeptInfoByIdWithToken: apiHost + "/Dept/getDeptInfoByIdWithToken",//通过科室Id获取科室详情
                getDeptByUserOrgId: apiHost + "/Dept/getDeptByUserOrgId",//获取科室下拉列表
            },
            user: {
                getByOrgAndSubjectAndProfessionalAndNameWithToken: apiHost + "/User/getByOrgAndSubjectAndProfessionalAndNameWithToken",//获取专家信息列表信息
                getByOrgAndSubjectAndProfessionalAndNameWithTokens: apiHost + "/User/getByOrgAndSubjectAndProfessionalAndNameWithTokens",//查询专家
                updateDisableStatusWithToken: apiHost + "/User/updateDisableStatusWithToken",//更改状态
                addExpertWithToken: apiHost + "/User/addExpertWithToken",//新增专家
                updateExpertWithToken: apiHost + "/User/updateExpertWithToken",//更新专家信息
                getUserInfoByIdWithToken: apiHost + "/User/getUserInfoByIdWithToken",//
                getUserPermList: apiHost + "/UserPerm/getUserPermList",//获取用户权限关联信息列表
                updateDataAuthority: apiHost + "/User/updateDataAuthority",//根据userId修改数据权限
                getUserListByOrgIdOrDeptIdOrName: apiHost + "/User/getUserListByOrgIdOrDeptIdOrName",//获取用户信息列表
                addUser: apiHost + "/User/addUser",//添加用户信息
                updateUser: apiHost + "/User/updateUser",//编辑更新用户信息
                selectUserName: apiHost + "/User/selectUserName",//判断是否存在相同用户名
                reSetPassword: apiHost + "/User/reSetPassword",//重置密码
                delUser: apiHost + "/User/delUser",//删除专家
                changePassword: apiHost + "/User/changePassword",//修改密码
                updateSignVerify: apiHost + "/User/updateSignVerify",//根据用户id更新用户签名短信验证状态
                updateCAVerify: apiHost + "/User/updateCAVerify",//根据用户id更新CA签名状态
                updateSignImg: apiHost + "/User/updateSignImg",//更新签名图片
                getHealthManageListByToken: apiHost + "/User/getHealthManageListByToken",//根据token获取健康管理员
            },
            menu: {
                getMenuList: apiHost + "/Menu/getMenuList",
                addMenu: apiHost + "/Menu/addMenu",
                updateMenu: apiHost + "/Menu/updateMenu",
                delMenu: apiHost + "/Menu/delMenu",
                getMenuTree: apiHost + "/Menu/getMenuTree",
            },
            orgCooper: {
                getOrgCooperInfo: apiHost + "/OrgCooper/getOrgCooperInfoWithToken",//协作医院
                cooperLocationNum: apiHost + "/OrgCooper/cooperLocationNum", //协作医院的地区分类的总数
                cooperLevelNum: apiHost + "/OrgCooper/cooperLevelNum", //协作医院的等级分类的总数
                getOrgCooperList: apiHost + "/OrgCooper/getOrgCooperList", //协作医院的机构列表的信息
                sortCooperOrg: apiHost + "/OrgCooper/sortCooperOrg", //协作医院的排序
                // cooperOrgName: apiHost + "/OrgCooper/cooperOrgNameWithToken", //根据机构ID获取协作医院名称列表
                selectOrgCooperByOrgId: apiHost + "/SubCenter/tsysorgcoop/selectOrgCooperByOrgId",  //根据分中心Id查询医联体-合作机构关系表
                getPlatformOrgs: apiHost + "/OrgCooper/getPlatformOrgs", //根据机构ID获取协作医院名称列表
                getDataAuthorityOrgList: apiHost + "/OrgCooper/getDataAuthorityOrgList",//
                getOrgCooperListWithToken: apiHost + "/OrgCooper/getOrgCooperListWithToken", //根据token 协作医院的机构列表的信息


            },
            subCenter: {
                selectAllSubcenter: apiHost + "/SubCenter/selectAllSubcenter", //根据机构ID获取分中心列表
            },
            finance: {
                unit: {
                    getAllPunit: apiHost + "/Punit/getAllPunit", //获取所有价表项目
                    getPunitList: apiHost + "/Punit/getPunitList", //获取价表信息列表
                    addPunit: apiHost + "/Punit/addPunit", //添加价表信息
                    updatePunit: apiHost + "/Punit/updatePunit", //更新价表信息
                    disPunit: apiHost + "/Punit/disPunit", //禁用价表信息
                    enablePunit: apiHost + "/Punit/enablePunit", //启用价表信息
                    delPunit: apiHost + "/Punit/delPunit", //删除价表信息
                },
                item: {
                    getPsuitList: apiHost + "/Psuit/getPsuitList", //获取价项信息列表
                    getPsuitListSelect: apiHost + "/Psuit/getAllPsuit", //获取所有价项下拉列表
                    addPsuit: apiHost + "/Psuit/addPsuit", //添加价项信息
                    delPsuit: apiHost + "/Psuit/delPsuit", //根据id 删除价项信息
                    delPsuits: apiHost + "/Psuit/delPsuits", //根据ids 批量删除价项信息
                    disPsuit: apiHost + "/Psuit/disPsuit", //根据id 禁用价项信息
                    enablePsuit: apiHost + "/Psuit/enablePsuit", //根据id 启用价项信息
                    updatePsuit: apiHost + "/Psuit/updatePsuit", //更新价项信息
                    getPsuitById: apiHost + "/Psuit/getPsuitById", //根据id 获取价项详细信息
                },
                mate: {
                    getPsetList: apiHost + "/Pset/getPsetList", //获取价配信息列表
                    getPsetById: apiHost + "/Pset/getPsetById", //根据id 获取价配详细信息
                    addPset: apiHost + "/Pset/addPset", //添加价配信息
                    delPset: apiHost + "/Pset/delPset", //根据id 删除价配信息
                    delPsets: apiHost + "/Pset/delPsets", //根据ids 批量删除价配信息
                    disPset: apiHost + "/Pset/disPset", //根据id 禁用价配信息
                    enablePset: apiHost + "/Pset/enablePset", //根据id 启用价配信息
                    updatePset: apiHost + "/Pset/updatePset", //更新价配信息
                },
                settle: {
                    getSettleManageList: apiHost + "/Settle/getSettleManageList", //获取结算管理列表
                    settleAndShare: apiHost + "/Settle/settleAndShare", //结算并分成
                    cancelSettle: apiHost + "/Settle/cancelSettle", //撤销结算
                    cancelDivide: apiHost + "/Settle/cancelDivide", //撤销分成
                    settleDivide: apiHost + "/Settle/settleDivide", //分成
                    reSettle: apiHost + "/Settle/reSettle", //分成
                    getConsItemByStatus: apiHost + "/Settle/getConsItemByStatus", //撤销分成
                },
                account: {
                    getIncomeListByTimeName: apiHost + "/UserAccount/getIncomeListByTimeName",//根据账号名称获取指定时间内流水信息（分中心下）
                },
            },
            SysLogs: {
                "getSysLogs": apiHost + "/SysLogs/getSysLogs",// 获取日志详情
                "SearchSysLogs": apiHost + "/SysLogs/SearchSysLogs",// 搜索日志
            },
            role: {
                "getRoleList": apiHost + "/Role/getRoleList",// 获取角色信息列表
                "addRole": apiHost + "/Role/addRole",// 新增角色功能
                "updateRole": apiHost + "/Role/updateRole",// 更新角色信息
                "delUser": apiHost + "/Role/delUser",// 根据userid 删除角色信息
                "getRoleById": apiHost + "/Role/getRoleById",// 根据roleid 获取角色详细信息
            },
            roleFunc: {
                "saveRoleFun": apiHost + "/RoleFunc/saveRoleFun",// 根据角色id和传入的功能id批量保存
            },
            center: {
                "getSubCenterList": apiHost + "/OrgCooper/getSubCenterList",// 获取所有分中心（用于下拉）
                "getSubCenterInfoList": apiHost + "/OrgCooper/getSubCenterInfoList",// 根据名称模糊查询分中心相关信息
                "getOrgInfoById": apiHost + "/Org/getOrgInfoById",//根据id获取分中心信息
                "saveSubCenter": apiHost + "/Org/saveSubCenter",//新增或修改分中心
                "forbiddenOrEnableOrg": apiHost + "/Org/forbiddenOrEnableOrg",//启用或禁用机构
                "getNoSubcenterList": apiHost + "/OrgCooper/getNoSubcenterList",//搜索所有非分中心的且状态为1的机构
                "getSubCenterConfig": apiHost + "/Org/getSubCenterConfig",//获取分中心配置
                "saveSubCenterConfig": apiHost + "/Org/saveSubCenterConfig",//保存分中心配置
                "getOrgListByNameExceptSelf": apiHost + "/Org/getOrgListByNameExceptSelf",//根据机构名称获取除本身外所有正常状态的机构列表
                "batchAddOrgCooper": apiHost + "/OrgCooper/batchAddOrgCooper",//批量添加医联体 旧的
            },
            subcenter: { //分中心信息相关接口 new
                "addSubCenterFromOrg": apiHost + "/SubCenter/addSubCenterFromOrg",// 根据机构新增分中心
                "addSubcenter": apiHost + "/SubCenter/addSubcenter",// 新增分中心
                "deleteSubcenterById": apiHost + "SubCenter/deleteSubcenterById",//根据id删除分中心信息表
                "getSubCenterIdByWebsite": apiHost + "/SubCenter/getSubCenterIdByWebsite",//根据域名获取分中心id
                "selectAllSubcenter": apiHost + "/SubCenter/selectAllSubcenter",//根据条件查询分中心信息表
                "selectSubcenterById": apiHost + "/SubCenter/selectSubcenterById",//根据主键查询分中心信息表
                "updateSubcenterById": apiHost + "/SubCenter/updateSubcenterById",//根据主键修改分中心信息表
                "forbiddenOrEnableSubCenter": apiHost + "/SubCenter/forbiddenOrEnableSubCenter",//启用或禁用分中心
            },
            //医联体 新 new
            tsyorgcoop: {
                "selectAllTSysOrgCoop": apiHost + "/SubCenter/tsysorgcoop/selectAllTSysOrgCoop", //根据条件查询医联体-合作机构关系表
                "addTSysOrgCoop": apiHost + "/SubCenter/tsysorgcoop/addTSysOrgCoop",  //批量添加医联体 新的
                "selectOrgCooperByOrgId": apiHost + "/SubCenter/tsysorgcoop/selectOrgCooperByOrgId",  //根据分中心Id查询医联体-合作机构关系表
                //"cooperOrgNameWithToken": apiHost + "/OrgCooper/cooperOrgNameWithToken",  根据分中心ID获取协作医院名称列表
                "deleteTSysOrgCoopById": apiHost + "/SubCenter/tsysorgcoop/deleteTSysOrgCoopById", //根据ID删除医联体-合作机构关系表
                "delOrgCoopByIds": apiHost + "/SubCenter/tsysorgcoop/delOrgCoopByIds", //根据分中心id和机构id 解除医联体-合作机构关系
            },
            //医联体 旧 old
            association: {
                "getOrgCooperMenuTree": apiHost + "/OrgCooper/getOrgCooperMenuTree",//获取分中心下的基层机构的对接关系
                "getOrgUppId": apiHost + "/OrgCooper/getOrgUppId",//获取医联体中基层机构的上级机构
                "getOrgExceptSelf": apiHost + "/OrgCooper/getOrgExceptSelf",//获取除了分中心本身以及选中基层机构以外的所有基层机构
                "addCooperationByOrgId": apiHost + "/OrgCooper/addCooperationByOrgId",//添加医联体对接协作关系
            }

        },
        //远程教学
        Education: {
            login: apiHost + "/Education/login", //远程教学登录
            regEduUser: apiHost + "/Education/regEduUser",//注册
            getPagingCourseListByNeed: apiHost + "/Education/getPagingCourseListByNeed",//课程列表 根据需求去查询
            getAllEduUserByType: apiHost + "/Education/getAllEduUserByType", //根据搜索条件获取分页用户数据
            getPagingEduOrgByNeed: apiHost + "/Education/getPagingEduOrgByNeed",  //根据 机构编号/名称/状态 查询所有医疗机构
            addEduArtical: apiHost + "/Education/addEduArtical", //新增文章
            getAllEduArtical: apiHost + "/Education/getAllEduArtical", //根据查询条件分页查询文章列表
            getSignDetailByCourseId: apiHost + "/Education/getSignDetailByCourseId",  //根据课程编号获取用户签到信息
            modEduArtical: apiHost + "/Education/modEduArtical", //修改新闻
            setArticleById: apiHost + "/Education/setArticleById",//文章 改变状态 文章操作 1：推荐 2：置顶 3：发布 4：取消推荐 5：取消置顶 6：取消发布 默认：1
            delEduArticalById: apiHost + "/Education/delEduArticalById",// 根据课程id删除课程
            getEduArticalById: apiHost + "/Education/getEduArticalById",//根据文章ID获取文章
            getAllEduCourseEnroll: apiHost + "/Education/getAllEduCourseEnroll",  //根据搜索条件获取分页课程报名数据
            updateEduUser: apiHost + "/Education/updateEduUser",  //修改远程教学用户基本信息
            addCourse: apiHost + "/Education/addCourse",  //添加课程信息
            getEduUserByUserId: apiHost + "/Education/getEduUserByUserId",  //根据用户编号获取用户信息
            addEduCourseEnroll: apiHost + "/Education/addEduCourseEnroll", //POST /Education/addEduCourseEnroll 新增课程报名
            signInOrSignOut: apiHost + "/Education/signInOrSignOut",//POST /Education/signInOrSignOut用户签到/签退
            getSignInfoByCourseId: apiHost + "/Education/getSignInfoByCourseId", //GET 根据课程编号获取签到信息
            modCourse: apiHost + "/Education/modCourse", //修改课程信息
            deleteCourseByCourseId: apiHost + "/Education/deleteCourseByCourseId", //删除课程
            getEnrollCourseList: apiHost + "/Education/getEnrollCourseList", //查询用户学习的课程信息
            getEduCommentByNeed: apiHost + "/Education/getEduCommentByNeed", //GET /Education/getEduCommentByNeed 根据评论编号/课程id/类型/评分/状态 查询所有评论
        },
        //远程教学
        teach: {
            getLessonListByTypeName: apiHost + "/WebTrainingLesson/getLessonListByTypeName",//根据课程类型、名称查询课程列表
            getStudentSignListByName: apiHost + "/WebTrainingLesson/getStudentSignListByName",//根据单位名称/姓名查询报名及签到信息列表
            createCourseSignIn: apiHost + "/WebTrainingLesson/createCourseSignIn",//创建课程签到缓存signToken
            updateSignIn: apiHost + "/WebTrainingLesson/updateSignIn",//学员课程签到
            changeLessonStatus: apiHost + "/WebTrainingLesson/changeLessonStatus",//改变课程的状态
            getLessonNameAndTime: apiHost + "/lessonSignTime/getLessonNameAndTime",//根据课程Id获取课程名称、签到开始时间、结束时间 (查询)
            addLessonTime: apiHost + "/lessonSignTime/addLessonTime",//根据课程Id获取课程名称、签到开始时间、结束时间 (添加)
            getLessonName: apiHost + "/lessonSign/getLessonName",//根据signToken 获取课程名称
            getCountStudentSignIn: apiHost + "/lessonSign/getCountStudentSignIn",//根据lessonId生成统计图
            getsignCountOfOrgByschedulId: apiHost + "/lessonSign/getsignCountOfOrgByschedulId",//会议签到机构统计报表
            getOrgNameListByLessonId: apiHost + "/lessonSign/getOrgNameListByLessonId",//根据signToken的lessonId获取在线培训医院列表
            deleteLessonTime: apiHost + "/lessonSignTime/deleteLessonTime",//根据排班ID删除课程排班
            getLastLessonBylessonId: apiHost + "/lessonSignTime/getLastLessonBylessonId",//根据课程Id获取详情
            getIndexLessonList: apiHost + "/WebTrainingLesson/getIndexLessonList",//首页课程列表
            getSmallLesson: apiHost + "/WebTrainingLesson/getSmallLesson",//获取大课程中的小课程
            getSignListByLessonSignString: apiHost + "/lessonSign/getSignListByLessonSignString",//根据课程、签到名称、（姓名、单位名称、部门科室、手机）向后模糊 查询签到列表
            addWebLesson: apiHost + "/WebTrainingLesson/addWebLesson",//
            getNoUpperIdLessonList: apiHost + "/WebTrainingLesson/getNoUpperIdLessonList",//查出所有课程主题id为0（没有上级id的）
            getLessonAndFilesById: apiHost + "/WebTrainingLesson/getLessonAndFilesById",//根据id获取课程信息及附件列表
            updateWebLesson: apiHost + "/WebTrainingLesson/updateWebLesson",//修改课程
            setLessonSorting: apiHost + "/WebTrainingLesson/setLessonSorting",//更改排序号
            getSignToken: apiHost + "/WebTrainingLesson/getSignToken",//生成报名signToken
        },
        loginUrl: apiHost + "/User/login",
        cmsLoginUrl: apiHost + "/Test/login",
        registerUrl: apiHost + "/User/regist",
        indexDoctorUrl: apiHost + "/Doctor/getDoctorListByPam?typeStr=1",
        cmsCommonList: apiHost + "/Common/getContextTop",
        cmsCommonDel: apiHost + "/Context/deleteById",
        cmsCommonAdd: apiHost + "/Context/SaveContextInfo",
        cmsCommonEdit: apiHost + "/Common/getContextByid",
        getUser: apiHost + "/Test/getUser",

        //会议
        Conference: {
            getDeviceListByNameUpperId: apiHost + "/AvcenterDevice/getDeviceListByNameUpperId",//根据设备名称和父级id获取树形设备列表
            getAllDeviceNoPageExceptSelf: apiHost + "/AvcenterDevice/getAllDeviceNoPageExceptSelf",//根据设备名称和父级id获取树形设备列表
            getAvcenterDeviceInfoById: apiHost + "/AvcenterDevice/getAvcenterDeviceInfoById",//根据id获取设备信息
            addAvcenterDevice: apiHost + "/AvcenterDevice/addAvcenterDevice",//新增设备
            updateAvcenterDevice: apiHost + "/AvcenterDevice/updateAvcenterDevice",//修改设备信息
            changeDeviceStatus: apiHost + "/AvcenterDevice/changeDeviceStatus",//删除设备
            querySites: onlineApi + sConferencePath + "/querySites",//获取会场列表
            queryConferencesStatus: onlineApi + sConferencePath + "/queryConferencesStatus",//获取会议列表
            scheduleConf: onlineApi + sConferencePath + "/scheduleConf",//预约非周期性会议
            delScheduledConf: onlineApi + sConferencePath + "/delScheduledConf",//删除预约会议或结束正在召开的会议
            getConfSitesByConfId: onlineApi + sConferencePath + "/getConfSitesByConfId",//根据会议ID获取会议中的会场
            queryConfSitesStatus: onlineApi + sConferencePath + "/queryConfSitesStatus",//根据会议ID获取正在进行的会议的会场
            addSiteToConf: onlineApi + sConferencePath + "/addSiteToConf",//向指定会议添加会场
            connectSites: onlineApi + sConferencePath + "/connectSites",//呼叫指定会议的一个或多个会场
            disconnectSites: onlineApi + sConferencePath + "/disconnectSites",//断开指定会议中与会的一个或多个会场
            delSiteFromConf: onlineApi + sConferencePath + "/delSiteFromConf",//删除已预约或已召开的会议中的会场
            deleteSiteInfo: onlineApi + sConferencePath + "/deleteSiteInfo",//删除会场信息
            addSiteInfo: onlineApi + sConferencePath + "/addSiteInfo",//添加会场信息
            editSiteInfo: onlineApi + sConferencePath + "/editSiteInfo",//添加会场信息
            getLiveUrl: onlineApi + sConferencePath + "/getLiveUrl",//获取直播路径
            getLiveRoomsList: onlineApi + sConferencePath + "/getLiveRoomsList",//获取直播列表
            getVideoLists: onlineApi + sConferencePath + "/getVideoLists",//获取节目列表
        },

        context: {
            saveWebContext: apiHost + "/WebContext/saveWebContext"
        },

        web: {
            linkManagement: {
                getWebLinksByStatus: apiHost + "/WebLink/getWebLinksByStatus",//根据机构状态查询WebLinks
                deleteWebLinkByKey: apiHost + "/WebLink/deleteWebLinkByKey",//根据主键将WebLink做删除操作
                saveWebLink: apiHost + "/WebLink/saveWebLink",//添加网站链接
                updateWebLink: apiHost + "/WebLink/updateWebLink",//修改网站链接
                getWebLinkById: apiHost + "/WebLink/getWebLinkById",//根据id获取
            },
            navigation: {
                changeStatus: apiHost + "/WebNavmenu/changeStatus",//修改导航菜单状态
                getNavMenuById: apiHost + "/WebNavmenu/getNavMenuById",//根据id获取导航菜单信息
                getParentMenuListByName: apiHost + "/WebNavmenu/getParentMenuListByName",//根据名称查询所有parentId为0的导航菜单列表
                getSonMenuList: apiHost + "/WebNavmenu/getSonMenuList",//GET /WebNavmenu/getSonMenuList
                saveNavMenu: apiHost + "/WebNavmenu/saveNavMenu",//添加或修改菜单导航

            },
            getMenusCascade: apiHost + "/WebNavmenu/getMenusCascadeWithToken",//根据orgID code获取二级菜单
            getMenuByCodeOrgId: apiHost + "/WebNavmenu/getMenuByCodeOrgId",//根据code、当前分中心查询菜单
            getContexts: apiHost + "/WebContext/getContextsWithToken",// 获取文章列表
            getAllNewsByOrgId: apiHost + "/WebContext/getAllNewsByOrgIdWithToken",// 根据orgId获取咨询中心全部新闻
            getWebContextById: apiHost + "/WebContext/getWebContextByIdWithToken",// 获取文章内容
            updateWebContext: apiHost + "/WebContext/updateWebContextWithToken",// 更新文章内容
            contextsOperation: apiHost + "/WebContext/contextsOperationWithToken",// 更新文章内容2
            saveWebContext: apiHost + "/WebContext/saveWebContextWithToken",// 新建文章内容
            deleteContext: apiHost + "/WebContext/deleteContextWithToken",// 删除文章
            updateTopStatus: apiHost + "/WebContext/updateTopStatus",// 置顶文章
            getMainNews: apiHost + "/WebNavmenu/getMainNewsWithToken", // 获取首页新闻
            getWebBaseConfigsBySecondDomain: apiHost + "/WebBaseConfig/getWebBaseConfigsBySecondDomain", // 根据域名获取orgId
            getWebLinks: apiHost + "/WebLink/getWebLinksWithToken", //友情链接
            getWebIndexMCenter: apiHost + "/WebIndexMCenter/getWebIndexMCenterWithToken",//获取首页医学中心
            getQuickEntryByToken: apiHost + "/SubCenter/getQuickEntryByToken",//根据token获取首页快速入口信息
            getQuickEntryByType: apiHost + "/SubCenter/getQuickEntryByType",//根据类型（医生端、管理端）获取首页快速入口信息
            doctor: {
                getDoctorAllStatus: apiHost + "/Doctor/getDoctorAllStatus",// 专家状态数量分布
                getDoctorList: apiHost + "/Doctor/getDoctorListWithToken",//获取专家列表
                getDoctorManageList: apiHost + "/Doctor/getDoctorManageList",//获取管理端专家信息列表
                getDoctorById: apiHost + "/Doctor/getDoctorByIdWithToken",//获取专家详情
                sortDoctor: apiHost + "/Doctor/sortDoctor",// 改变专家排序
                changeDoctorStatus: apiHost + "/Doctor/changeDoctorStatus",// 专家状态修改
                getDoctorListWithToken: apiHost + "/Doctor/getDoctorListWithToken", //获取专家信息列表（首页推荐） 新接口
            },
            getLessonList: apiHost + "/WebTrainingLesson/getLessonListWithToken", //获取课程列表
            getLessonDetail: apiHost + "/WebTrainingLesson/getLessonDetailWithToken", //获取课程详情
            getWebLessonFileList: apiHost + "/WebLessonFile/getWebLessonFileListWithToken", //下载课程资料

            getContextsByNavCode: apiHost + "/WebContext/getContextsByNavCode", //医学中心列表

            getLessonStatisticsWithToken: apiHost + "/WebTrainingLesson/getLessonStatisticsWithToken",//获取课程统计详情
            getLessonListWithToken: apiHost + "/WebTrainingLesson/getLessonListWithToken", //获取课程列表
            getLessonFileStatisticsWithToken: apiHost + "/WebLessonFile/getLessonFileStatisticsWithToken",//获取课程附件统计详情
            getLessonsByConditionsWithToken: apiHost + "/WebTrainingLesson/getLessonsByConditionsWithToken",//通过条件搜索课程
            lessonOperationWithToken: apiHost + "/WebTrainingLesson/lessonOperationWithToken",//通过id对课程批量进行发布，推荐操作
            //下载中心
            webDownload: {
                getFileCateList: apiHost + "/WebDownload/getFileCateList",//获取材料分类列表
                changeStatus: apiHost + "/WebDownload/changeStatus",//修改下载文件状态
                getFileInfoById: apiHost + "/WebDownload/getFileInfoById",//根据id获取下载文件信息
                getFileListByCate: apiHost + "/WebDownload/getFileListByCate",//根据类型查询文件列表
                insertWebFile: apiHost + "/WebDownload/insertWebFile",//添加网站文件
                updateWebFile: apiHost + "/WebDownload/updateWebFile",//修改网站下载文件
            },
        },
        // 患者中心
        patient: {
            deletePatient: apiHost + "/Patient/deletePatient",//根据患者id删除患者
            getPatientsByOrgName: apiHost + "/Patient/getPatientsByOrgName",// 根据机构id、患者姓名获取患者信息
            getPatientInfoById: apiHost + "/Patient/getPatientInfoById",//根据主键Id查询患者基本信息
            getCurTitles: apiHost + "/Patient/getCurTitles",// 获取当前会诊的章节列表
            getTitlesByCaseId: apiHost + "/Patient/getTitlesByCaseId",// 点击时间列表中的时间获取某一次会诊的章节列表
            getFileByDocType: apiHost + "/Patient/getFileByDocType",// 根据文档类型获取文件列表
            getHistoryList: apiHost + "/Patient/getHistoryList",//获取历史会诊
            saveCaseIndex: apiHost + "/Patient/saveCaseIndex",//新增患者基本信息
            updatePatientInfo: apiHost + "/Patient/updatePatientInfo",//修改患者基本信息
            getTwoMenu: apiHost + "/Patient/getTwoMenu",// 查询二级菜单，一级类别为文档类型
            getDoctorListByDeptId: apiHost + "/Doctor/getDoctorListByDeptId",//获取医生下拉列表
            getViewImageInfo: apiHost + "/Case/getViewImageInfo",//根据token获取用户详细信息
            getApplyInfoByPatientId: apiHost + "/Apply/getApplyInfoByPatientId",//根据患者id获取申请单id
            loginNaLongDemo: apiHost + "/Education/loginNaLongDemo",//心电图 api
            loginNaLong: onlineApi + "/ECG/loginNaLong", //远程心电  获取第三方api的接口-》纳龙
            getPatientInfo: apiHost + "/thirdPatien/getPatientInfo", //【福能】根据体检号获取患者信息
            getPatientReport: apiHost + "/thirdPatien/getPatientReport", //【福能】根据体检号获取患者报告地址

        },
        // 影像
        images: {
            // 医真token
            getImagesToken: "http://api.yizhen.cn/amol-back/oauth/token?client_id=amol_client_tpp&client_secret=amol_secret_tpp&grant_type=password&username=clinicalAPI&password=clinical@yizhen",
            getPatientApplyAndReport: "http://api.yizhen.cn/amol-back/clinical/getPatientApplyAndReport",
            getKyImageInfo: onlineApi + "/Image/getKyImageInfo",//获取卡易影像
            getYDImageInfo: onlineApi + "/Image/getYDImageInfo",//获取影达影像
            AIStudyUpload: onlineApi + "/AIImage/AIStudyUpload",//上传检查信息(腾讯)
            AIGetAiResult: onlineApi + "/AIImage/AIGetAiResult",//获取AI检查结果(腾讯)
            getImageInfoList: onlineApi + "/Image/getImageInfoList",
        },
        // 病历
        case: {
            insertCaseDoc: apiHost + "/Case/insertCaseDoc",// 新增病历文档,仅增加单条记录
            uploadDocs: apiHost + "/Case/uploadDocs",// 根据传入的数据批量新增doc
            deleteById: apiHost + "/Case/deleteById",// 根据id删除doc记录
            getViewImageInfo: apiHost + "/Case/getViewImageInfo",//根据id获取影像厂商通道
            saveECG: apiHost + "/Case/saveECG",  //平台保存报告数据（平台） 心电 对接纳龙
            getAllECGByCaseId: apiHost + "/Case/getAllECGByCaseId", //获取所有心电列表 对接纳龙
            deleteECGById: apiHost + "/Case/deleteECGById",//根据ID删除心电图记录
            //影像列表
            Imagelist: {
                getImageDetailByCheckNo: apiHost + "/Case/getImageDetailByCheckNo",//获取检查类型等需要从dict_class表中查询的数据
                getDictClassByUpperId: apiHost + "/Case/getDictClassByUpperId",//获取检查类型等需要从dict_class表中查询的数据
                getDictByUpperId: apiHost + "/Case/getDictByUpperId",//获取检查项目等需要从dict表中查询的数据
                savePaces: apiHost + "/Case/savePaces",//影像列表点击保存时，批量新增或修改影像记录
                deleteById: apiHost + "/Case/deleteById",//根据id删除
                deletePacsById: apiHost + "/Case/deletePacsById",//根据id删除影像记录
                updatePacsUrlById: apiHost + "/Case/updatePacsUrlById",//根据id删除影像记录
                getAIinfoList: apiHost + "/Case/getAIinfoList",//获取患者ai信息
                getPatientImagesInfo: apiHost + "/Case/getPatientImagesInfo",//获取患者ai信息
                saveAIinfo: apiHost + "/Case/saveAIinfo",//保存患者ai信息
                uploadAIImage: apiHost + "/Case/uploadAIImage",//根据传入的数据批量新增AI影像
                addAiResult: apiHost + "/Case/addAiResult",//添加ai结果信息

            },
        },
        //配置影像厂商
        ConfigSource: {
            ConfigImage: apiHost + "/ConfigImage/saveOrUpdateConfigImage",//添加或更新影像配置信息
        },
        TwoWayReferral: {
            getReferralList: apiHost + "/Referral/getReferralList",//双向转诊列表
            getReferralInfoById: apiHost + "/Referral/getReferralInfoById",//根据申请单Id获取详情
            saveReferralApply: apiHost + "/Referral/saveReferralApply",//保存双向转诊申请单
            submitReferralApply: apiHost + "/Referral/submitReferralApply",//提交双向转诊申请单
            updateInto: apiHost + "/Referral/updateInto",//转入修改
            getReferralOrgAndDeptById: apiHost + "/Referral/getReferralOrgAndDeptById",//根据申请单Id获取下转机构和科室
            submitUpApply: apiHost + "/Referral/submitUpApply",//提交上转单
            turnDownReferral: apiHost + "/Referral/turnDownReferral",//双向转诊下转
            updateRollOut: apiHost + "/Referral/updateRollOut",//转出修改
            getExpertProcessInfoById: apiHost + "/Referral/getExpertProcessInfoById",//根据双向转诊ID查询专家治疗过程

        },

        // 影像会诊
        MC: {
            sentImageMsg: apiHost + "/Apply/sentImageMsg",  //发送短信
            saveReportUrl: apiHost + "/Apply/saveReportUrl",  //保存报告地址
            getCurrentStep: apiHost + "/Apply/getCurrentStepByApplyId",  //根据申请单id获取申请单当前环节
            storeCaseIndex: apiHost + "/Apply/storeCaseIndex",  //申请方医生进入接受与评价页面时调用,归档
            getJobAccount: apiHost + "/RccIndex/getJobAccount",//首页-工作统计
            getApplyList: apiHost + "/RccIndex/getApplyList",//首页-列表
            getNotApply: apiHost + "/RccIndex/getNotApply",//首页-未申请列表
            getPlatformStats: apiHost + "/RccIndex/getPlatformStats",//首页-平台统计
            getPacsProfessional: apiHost + "/RccIndex/getPacsProfessional",//首页-专家推荐
            getRccApplyList: apiHost + "/RccIndex/getRccApplyList",//获取影像会诊首页的工作统计相关数据
            getApplyInfoBySearchString: apiHost + "/RccIndex/getApplyInfoBySearchString",//根据多个条件查询会诊信息
            getInvalidApplyList: apiHost + "/RccIndex/getInvalidApplyList",//获取已作废的申请单列表
            getApplyListForMonitor: apiHost + "/RccIndex/getApplyListForMonitor",//获取监控页面会诊列表
            //资料审核
            getApply: apiHost + "/Apply/getApply",//获取审核操作
            getApplyTabBasicInfo: apiHost + "/Apply/getApplyTabBasicInfo",//获取影像会诊申请单的基本患者信息
            cancelTheSubmit: apiHost + "/Apply/addRepealApplyOpera",//撤销审核结果
            addApplyOperaCommit: apiHost + "/Apply/addApplyOperaCommit",//提交审核结果
            //分诊
            getAllOrgCooperName: apiHost + "/ApplyTarget/getAllOrgCooperName",//分诊- 根据token 获取受邀方机构下拉列表
            selectDeptIdNameByOrgId: apiHost + "/ApplyTarget/selectDeptIdNameByOrgId",//分诊- 根据机构id 获取受邀方科室下拉列表
            getDoctorListByDepts: apiHost + "/Apply/getDoctorListByDepts",//分诊- 根据机构id 获取受邀方医生列表
            getTriageInfo: apiHost + "/Triage/getTriageInfo",//分诊- 根据申请单Id获取分诊详细信息
            saveTriage: apiHost + "/ApplyTarget/updateApplyTarget",//分诊- 分诊
            cancelTriage: apiHost + "/ApplyTarget/cancelTriageSubmit",//分诊- 撤销分诊
            getUserIdByToken: apiHost + "/Account/getUserId",//根据token获取用户id
            getOpenRoomList: apiHost + "/ConfigMediaroom/getOpenRoomList",//分诊- 会诊室下拉列表
            addPatientFollow: apiHost + "/Patient/addPatientFollow",//新增患者随访信息
            selectAllPatientFollow: apiHost + "/Patient/selectAllPatientFollow",//新增患者随访信息
            updatePatientFollowById: apiHost + "/Patient/updatePatientFollowById",//新增患者随访信息
            //多学科
            mdtconsult: {
                getTargetOrgAndDeptByApplyId: apiHost + "/MDTConsult/getTargetOrgAndDeptByApplyId",//通过申请单Id查找选择的受邀机构和科室
                saveMDTConsultInfo: apiHost + "/Consult/saveMDTConsultInfo",//提交多学科会诊信息
                preSaveMDTConsultInfo: apiHost + "/Consult/preSaveMDTConsultInfo",//保存多学科会诊信息
                MDTconsultRepealCommit: apiHost + "/Consult/MDTconsultRepealCommit",//撤销多学科会诊信息
                InvalidMDTconsultReport: apiHost + "/Consult/InvalidMDTconsultReport",//作废多学科会诊报告信息
                getMDTConsultInfo: apiHost + "/Consult/getMDTConsultInfo",//多学科会诊-获取会诊报告信息
                MDTconsultReportRepealCommit: apiHost + "/Consult/MDTconsultReportRepealCommit",//会诊报告单撤销提交
                getTargetInfoList: apiHost + "/ApplyTarget/getTargetInfoList",//多学科会诊-获取会诊报告信息
                getCommitVisible: apiHost + "/Consult/getCommitVisible",//获取提交状态
                commitTriageInfo: apiHost + "/MDTConsult/commitTriageInfo",//提交分诊信息
                getMDTApplyFormInfo: apiHost + "/MDTConsult/getMDTApplyFormInfo",//获取多学科会诊申请单的基本患者信息
                addMDTApplicationForm: apiHost + "/MDTConsult/addMDTApplicationForm",//新增多学科申请单
                updateMDTApplicationForm: apiHost + "/MDTConsult/updateMDTApplicationForm",//修改多学科申请单
                cancelTriageInfo: apiHost + "/MDTConsult/cancelTriageInfo",//撤销提交分诊
                saveTriageInfo: apiHost + "/MDTConsult/saveTriageInfo",//保存分诊信息
                getSelectedItemdetails: apiHost + "/MDTConsult/getSelectedItemdetails",//通过申请单号获取选择的医生项目信息
                addMDTReportCheck: apiHost + "/MDTConsult/addMDTReportCheck",//提交报告核对
                saveMDTReportUrl: apiHost + "/MDTConsult/saveMDTReportUrl",//保存多学科会诊报告地址
            },
            // 申请单
            apply: {
                keepUserOnline: apiHost + "/Apply/keepUserOnline",// 保持用户在线
                getClientOrgEmergencyPrice: apiHost + "/Apply/getClientOrgEmergencyPrice",// 获取当前登录分中心对应的急诊费用
                getAllUserOnlineStatus: apiHost + "/Apply/getAllUserOnlineStatus",// 获取当前申请单中医生现在状态
                getApplyTabBasicInfo: apiHost + "/Apply/getApplyTabBasicInfo",// 获取影像会诊申请单的基本患者信息
                getClassSixDeptDoctorList: apiHost + "/Apply/getClassSixDeptDoctorList",// 获取影像会诊申请单的医生列表
                getConsItem: apiHost + "/Apply/getConsItem",// 获取会诊项目列表
                getConsGoal: apiHost + "/Apply/getConsGoal",// 获取会诊目的列表
                getDoctorListByDepts: apiHost + "/Apply/getDoctorListByDepts",// 获取会诊目的列表
                saveApplicationForm: apiHost + "/Apply/saveApplicationForm",// 保存或提交申请单
                addReportCheck: apiHost + "/Apply/addReportCheck",//报告核对
                getEvaluateReport: apiHost + "/Apply/getEvaluateReport",//获得评价区
                addEvaluate: apiHost + "/Apply/addEvaluate",//新增星级评价
                addRepealCommit: apiHost + "/Apply/addRepealCommit",//报告核对撤销通过
                addRefuseReport: apiHost + "/Apply/addRefuseReport",//报告核对拒绝
                applyRepealCommit: apiHost + "/Apply/applyRepealCommit",//申请单撤销
                getwxPay: onlineApi + "/Wxpay/pay",//获取微信扫码二维码
                getzfbPay: onlineApi + "/Alipay/pay",//获取支付宝扫码二维码
                payResult: onlineApi + "/Wxpay/payResult",//扫码支付后 调用结果
                getApplyNo: apiHost + "/Apply/getApplyNo",//根据申请单id获取申请单当前环节
                makeApplyInvalid: apiHost + "/Apply/makeApplyInvalid",//申请单作废
                skipConsultationTip: apiHost + "/Apply/skipConsultationTip",//30天内不再提示接口 consultType：申请会诊类型（0-影像会诊 1-临床会诊 2-多学科）
            },
            //会诊
            consult: {
                saveConsultInfo: apiHost + "/Consult/saveConsultInfo",//提交会诊信息
                preSaveConsultInfo: apiHost + "/Consult/preSaveConsultInfo",//保存会诊信息
                consultRepealCommit: apiHost + "/Consult/consultRepealCommit",//撤销会诊信息
                getConsultInfo: apiHost + "/Consult/getConsultInfo",//会诊-获取会诊报告信息
                scheduleConf: onlineApi + "/Conference/scheduleConf",//呼叫软终端
                getAllUserByApplyId: apiHost + "/ConfigMediaroom/getAllUserByApplyId",//根据申请单id获取对应会诊室账户信息中所有username
                getConsultMsgType: apiHost + "/Consult/getConsultMsgType",//会诊是否短信验证
                validMsg: apiHost + "/Consult/validMsg",//短信验证码验证
                sendImgCode: onlineApi + "/Message/sendImgCode",//发送验证码
                sendPhoneCode: onlineApi + "/Message/sendPhoneCode", //发送验证码到手机
            },
        },
        //会诊室
        MediaRoomConfig: {
            addMediaroom: apiHost + "/ConfigMediaroom/addMediaroom",//添加会议室
            updateMediaroom: apiHost + "/ConfigMediaroom/updateMediaroom",//更新会议室
            delMediaroom: apiHost + "/ConfigMediaroom/delMediaroom",//删除会议室
            getRoomListNotDelByNameDevice: apiHost + "/ConfigMediaroom/getRoomListNotDelByNameDevice",//根据会诊室名称（向后模糊）和接入设备获取会诊室列表
            getRoomInfoById: apiHost + "/ConfigMediaroom/getRoomInfoById",//根据会议室id查询会议室信息
        },

        //SysNotice 决策分析 消息数据
        SysNotice: {
            getNoticeList: apiHost + "/SysNotice/getNoticeList", //获取消息数据 旧的 监控
            updateNotices: apiHost + "/SysNotice/updateNotices", //更新消息数据
            getNoticeListBytoken: apiHost + "/SysNotice/getNoticeListBytoken", //获取消息数据 新的接口 监控
        },

        //新-双向转诊 20190802
        RccReferral: {
            // POST /RccReferral/addRccApplyDualreferral 新增双向转诊主表
            // POST /RccReferral/deleteRccApplyDualreferralById根据ID删除双向转诊主表
            // GET /RccReferral/selectAllRccApplyDualreferral 根据条件查询双向转诊主表
            // GET /RccReferral/selectRccApplyDualreferralById 根据主键查询双向转诊主表
            // POST /RccReferral/updateRccApplyDualreferralById 根据主键修改双向转诊主表
            // getAllRccApplyDualreferralByPatient 根据token，查询所有双向转诊数据
            addRccApplyDualreferral: apiHost + "/RccReferral/addRccApplyDualreferral",
            deleteRccApplyDualreferralById: apiHost + "/RccReferral/deleteRccApplyDualreferralById",
            selectAllRccApplyDualreferral: apiHost + "/RccReferral/selectAllRccApplyDualreferral",
            selectRccApplyDualreferralById: apiHost + "/RccReferral/selectRccApplyDualreferralById",
            updateRccApplyDualreferralById: apiHost + "/RccReferral/updateRccApplyDualreferralById",
            getAllRccApplyDualreferralByPatient: apiHost + "/RccReferral/getAllRccApplyDualreferralByPatient",
            updateRccApplyDualreferralStepById: apiHost + "/RccReferral/updateRccApplyDualreferralStepById",

        },
        Telemedicine: {
            addScheduling: apiHost + "/Telemedicine/scheduling/addScheduling", //新增排班管理表
            getScheduling: apiHost + "/Telemedicine/scheduling/getScheduling",//根据特定条件查询所有排班表
            selectAllTelemedicineService: apiHost + "/Telemedicine/service/selectAllTelemedicineService", //根据条件查询服务管理
            addDoctorService: apiHost + "/Telemedicine/doctorservice/addDoctorService",//新增医生服务
            selectAllDoctorService: apiHost + "/Telemedicine/doctorservice/selectAllDoctorService",//根据条件查询医生服务管理
            updateDoctorServiceById: apiHost + "/Telemedicine/doctorservice/updateDoctorServiceById",
            selectAllNotOpenServiceByDoctorId: apiHost + "/Telemedicine/doctorservice/selectAllNotOpenServiceByDoctorId",           // 根据医生Id查询所有未开通的服务列表"
            selectAllDoctorByServiceId: apiHost + "/Telemedicine/doctorservice/selectAllDoctorByServiceId",//            根据服务Id和部门Id查询该部门所有开通该服务的医生列表
            getNumberCountForSevenDays: apiHost + "/Telemedicine/queuenumber/getNumberCountForSevenDays", //根据条件获取传入日期之后7天的所有医生号源统计情况
            selectAllQueueNumber: apiHost + "/Telemedicine/queuenumber/selectAllQueueNumber",//         根据条件查询号源表
        },
        TeleOrder: {
            getTelemedicineOrderInfo: apiHost + "/TeleOrder/getTelemedicineOrderInfo",
            getTelemedicineOrderByParam: apiHost + '/TeleOrder/getTelemedicineOrderByParam',//医生端 远程问诊-服务列表
            endService: apiHost + "/TeleOrder/endService",//      医生端 /endService医生端 结束问诊
            startService: apiHost + "/TeleOrder/startService",//      医生端 开始服务/开始问诊
            rejectService: apiHost + "/TeleOrder/rejectService",//      医生端 拒绝服务
            getDoctorInfo: apiHost + "/TeleOrder/getDoctorInfo",//医生基本信息
        },
        WyyController: {
            getWyyAccidByLoginName: onlineApi + "/WyyController/getWyyAccidByLoginName", //    根据平台登入名获取网易云accid
            getWyyTokenByToken: onlineApi + "/WyyController/getWyyTokenByToken", // 根据token获取 密码
            updateWyyTokenByToken: onlineApi + "/WyyController/updateWyyTokenByToken", //根据平台token更新并获取新网易云token
        },
        //云霄医院 获取影像申请单诊断 数据 自动填入
        diagtpl: {
            selectAllDiagTplForTree: apiHost + "/Infrastructure/diagtpl/selectAllDiagTplForTree"
        },
        //协作端
        Collaboration:{
            selectSubcenterById: apiHost + "/SubCenter/selectSubcenterById",//根据分中心id获取机构Id
            getAllOrgListUrl: apiHost +"/Org/getAllOrgList",// 专家预约  获取医院
            getDeptListByOrgIdUrl: apiHost +"/Dept/getDeptListByOrgId",//专家预约   通过医院机构Id获取所有部门包含该部门下的医生数量
            getNumberDeptAndTotalDoctor: apiHost +"/Telemedicine/queuenumber/getNumberDeptAndTotalDoctor",//专家预约 根据条件获取传入日期之后7天的所有可预约部门和医生数量
            getNumberCountForSevenDaysUrl: apiHost +"/Telemedicine/queuenumber/getNumberCountForSevenDays",//专家预约   通过选择部门获取号源统计
            selectAllTelemedicineServiceUrl: apiHost +"/Telemedicine/service/selectAllTelemedicineService",//专家预约   通过服务名称模糊查询服务ID
            getDoctorInfoUrl: apiHost +"/TeleOrder/getDoctorInfo",// 专家预约详情界面  通过专家预约界面传递过来的当前选中医生Id获取专家医生信息
            selectAllQueueNumberUrl:apiHost +"/Telemedicine/queuenumber/selectAllQueueNumber",// 专家预约详情界面  根据条件查询号源表
            addRemoteInquiryOrderUrl:apiHost +"/TeleOrder/addRemoteInquiryOrder",// 专家预约表单界面  专家预约3-预约远程门诊

            getMyRemoteInquiryOrderByParamUrl:apiHost +"/TeleOrder/getMyRemoteInquiryOrderByParam",// 协作端 查询-远程门诊订单列表/协作端 远程门诊-患者列表
            selectDoctorAdviceByOrderIdUrl:apiHost +"/Telemedicine/doctoradvice/selectDoctorAdviceByOrderId",// 远程门诊列表-查看  根据订单Id查询医嘱信息表
            getRemoteInquiryApplyInfoUrl:apiHost +"/TeleOrder/getRemoteInquiryApplyInfo",// 远程门诊 协作端/专家端 远程门诊-患者申请信息
            getNumberDeptAndTotalDoctor:apiHost +"/Telemedicine/queuenumber/getNumberDeptAndTotalDoctor",
            getDoctorRemoteInquiryOrderByParamUrl:apiHost +"/TeleOrder/getDoctorRemoteInquiryOrderByParam",// 专家端 查询-远程门诊订单列表/专家端 远程门诊-患者列表
            updateDoctorAdviceAndDiagnoseUrl:apiHost +"/Telemedicine/doctoradvice/updateDoctorAdviceAndDiagnose",// 专家端 修改医嘱并新增或修改诊断信息
            beReadyService:apiHost+"/TeleOrder/beReadyService", //协作端-远程门诊 已就绪
            nextService:apiHost+"/TeleOrder/nextService", //专家端医生，进行下一位患者
            endClinicService:apiHost+"/TeleOrder/endClinicService", //专家端 专家结束问诊

            getDrugListByParamUrl:apiHost+"/TeleDrug/getDrugListByParam", //查询字典 药品列表
            getDictUnitListUrl:apiHost+"/TeleDrug/getDictUnitList", //查询字典 药品剂量单位列表
            getDictSkinTestTypeListUrl:apiHost+"/TeleDrug/getDictSkinTestTypeList", //查询字典 皮试类型列表
            getDictFrequencyListUrl:apiHost+"/TeleDrug/getDictFrequencyList", //查询字典 用药频次列表
            getDictDrugUsageMethodListUrl:apiHost+"/TeleDrug/getDictDrugUsageMethodList", //查询字典 用药方法列表

            getDictInspectListByParam:apiHost+"/TeleDrug/getDictInspectListByParam", //查询字典 检查列表
            getDictExamineListByParam:apiHost+"/TeleDrug/getDictExamineListByParam", //查询字典 查询字典 检验列表
            getDictTreatListByParam:apiHost+"/TeleDrug/getDictTreatListByParam", //查询字典 治疗列表

            updateDoctorAdviceAndDiagnoseUrl:apiHost+"/Telemedicine/doctoradvice/updateDoctorAdviceAndDiagnose", //修改医嘱并新增或修改诊断信息并新增或修改处方信息
            deletePrescriptionInfoById:apiHost+"/Telemedicine/telemedicineprescriptioninfo/deletePrescriptionInfoById", //根据ID删除处方表
            deletePrescriptionDetailById:apiHost+"/Telemedicine/prescriptiondetail/deletePrescriptionDetailById", //根据ID删除处方明细表
            copyAdviceFromDoctor:apiHost+"/Telemedicine/doctoradvice/copyAdviceFromDoctor", //从建议医嘱复制信息


        },
        websocket:{
            login: apiHost + "/websocket/login", //websocket通讯相关API login
        },
        //远程查房
        TeleRoundsInfo:{
            getRoundsInfoByApplyId: apiHost + "/Telemedicine/telemedicineroundsapply/getRoundsInfoByApplyId",//根据主键查询远程查房申请主表/
            updateRoundsApplyStatusById: apiHost + "/Telemedicine/telemedicineroundsapply/updateRoundsApplyStatusById",///根据主键修改远程查房申请单状态
            addRoundsApply: apiHost + "/Telemedicine/telemedicineroundsapply/addRoundsApply",//新增远程查房申请主表
            getDictDiagnosticList: apiHost + "/TeleDrug/getDictDiagnosticList",//查询字典 诊断列表
            materialAudit: apiHost + "/TeleRoundsInfo/materialAudit",///申请材料审核
            addTeleOrderFiles: apiHost + "/Telemedicine/file/addTeleOrderFiles",///添加附件信息
            updateDoctorReadyById: apiHost +"/Telemedicine/telemedicineroundsapply/updateDoctorReadyById",//医生就绪操作
            selectAllRoundsApplyForHome: apiHost + "/Telemedicine/telemedicineroundsapply/selectAllRoundsApplyForHome",//首页  根据条件查询远程查房申请主表
            addDoctorAdvice: apiHost + "/Telemedicine/doctoradvice/addDoctorAdvice",//开具医嘱  新增医嘱信息表
            saveTreatmentAdvise: apiHost +  "/TeleRoundsInfo/saveTreatmentAdvise",//提交诊疗意见
            saveEndRoundsTime: apiHost + "/TeleRoundsInfo/saveEndRoundsTime",//结束视频聊天-保存查房结束时间
            saveStartRoundsTime: apiHost + "/TeleRoundsInfo/saveStartRoundsTime",//开启视频聊天-保存查房开始时间
        },
        report:{
            selectExpertConsByDate:apiHost+"/report/expertConsStatistical/selectExpertConsByDate",//根据条件查询专家会诊情况月统计表
        },
        //CA签名
        geCaName: {
            signDataWithExtraInfo: onlineApi + "/CertificateAuthority/signDataWithExtraInfo",//不验证口令签名（带取证查询扩展信息）
            getSignPictureByInfo: onlineApi + "/CertificateAuthority/getSignPictureByInfo",//通过身份信息以及申请单id获取签名图片
        },



};
module.exports = conf;



// WEBPACK FOOTER //
// ./public/config/conf.js